import { InventoryState } from './reducer';

export const counter = (state: InventoryState) => state.counter;
export const user = (state: InventoryState) => state.user;
export const awsTokens = (state: InventoryState) => state.awsTokens;
